import Experiment from './Experiment';
export default Experiment;
